const Switch = (props, children) => children.find(child => Boolean(child));

export { Switch };



// WEBPACK FOOTER //
// ./src/templates/switch.js